import { Grid } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import React from "react";
import { useQuery } from "react-query";

import { Async } from "../../../../components/Async";
import { CreateButton } from "../../../../components/create_button";
import { ListTable } from "../../../../components/list_table";
import { QUERY_KEYS } from "../../../../constants";
import { ROUTES } from "../../../../routes";
import { IExpense } from "../../data/entities";
import { ExpenseRepoImpl } from "../../data/repo";

export const ExpenseListPage: React.FC = () => {
  const asyncExpenseList = useQuery(QUERY_KEYS.expenseList, () => ExpenseRepoImpl.getList());

  return (
    <div>
      <CreateButton route={ROUTES.expense} />

      <Grid container justify="center">
        <Grid item xs={12} sm={12} md={6}>
          <Async
            asyncData={asyncExpenseList}
            renderSuccess={(expenseList) => {
              return (
                <ListTable<IExpense>
                  branch={expenseList}
                  route={ROUTES.expense}
                  canEdit
                  renderHeader={() => (
                    <>
                      <TableCell>Ad</TableCell>
                    </>
                  )}
                  renderRow={(expense) => (
                    <>
                      <TableCell>{expense.name}</TableCell>
                    </>
                  )}
                />
              );
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};
